import { httpRequest, stringifyGraph } from '@/clients/http'
import { PosModel } from '@/types'

export const BranchModel = {
  /** Every branch with its terminals: admins can set a device up in any branch (`branches:list`). */
  getAllWithTerminals: () =>
    httpRequest<{ result: PosModel.Branch[] }>({
      method: 'get',
      url: '/api/backoffice/branch',
      query: { page: 1, length: 200, graph_enc: stringifyGraph({ '*': true, terminals: { '*': true } }) },
    }),
}
